import axios from "~/axios";
import {normalizeHelpData} from "~/selectors/searchHelpData";
import { default as  defaultAuthenticatedRequest} from "~/backend/authenticatedRequest";



export default async function fetchHelpData(baseUrl, authenticatedRequest = defaultAuthenticatedRequest) {
    let helpResultsUrl = `${baseUrl}/help_articles/results?rows=10000`;

    let helpData = await authenticatedRequest(async () => {
        let axData = await axios.get(helpResultsUrl);
        return axData.data;
    });

    helpData.results = normalizeHelpData(helpData.results);

    return helpData;
}